/* custom.js — Fabric by Missy Rose
 * Rewritten 6 Oct 2026 (Claude) from the previous minified version. Same features, with fixes:
 *  - Sticky "Add to Cart" bar works again (stickyBtn was never defined, so tapping it did nothing).
 *  - Sticky bar now follows the fabric/size/quantity chosen in the main product options.
 *  - The sticky bar presses the main Add button, so iCart adds the item and opens its drawer (it used to call the removed UpCart app).
 *  - Removed UpCart leftovers (minQuantityUpdate + a wrapper that ran after every network request).
 *  - Sliders wait for the Flickity library instead of crashing the rest of this file when it loads late.
 *  - Phones: sticky bar is slimmer, and the chat bubble no longer covers the product options.
 *  - Quick view content loads on demand, so collection pages are a fraction of the size.
 *  8 Oct: sticky bar price shows as text (was showing <span class=money> code); single-option products hide the "Default Title" dropdown.
 *  23 Oct: quick view waits for its (now lazy) script; accessibility fixer stops re-scanning the page on every DOM change.
 *  24 Oct: the cart drawer opener also works with the theme's own drawer (?mrcart=native).
 */

/* ---------- Back to top button ---------- */
function initBackToTop2() {
  const btn = document.querySelector(".back-to-top-main");
  const path = document.querySelector(".back-to-top-circle-progress-path");
  if (!btn || !path) return;
  const total = path.getTotalLength();
  path.style.strokeDasharray = total;
  path.style.strokeDashoffset = total;
  window.addEventListener("scroll", function () {
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const y = window.scrollY;
    if (y > 50) { btn.style.opacity = 1; btn.style.pointerEvents = "all"; }
    else { btn.style.opacity = 0; btn.style.pointerEvents = "none"; }
    const progress = max > 0 ? Math.min(y / max, 1) : 0;
    path.style.strokeDashoffset = y >= max ? 0 : total * (1 - progress);
  }, { passive: true });
  btn.addEventListener("click", () => window.scrollTo({ top: 0, behavior: "smooth" }));
}
document.addEventListener("DOMContentLoaded", initBackToTop2);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener("shopify:section:unload", initBackToTop2);
  document.addEventListener("shopify:section:load", initBackToTop2);
}

/* ---------- Open the cart drawer ---------- */
function mrOpenCartDrawer() {
  // 24 Oct: with the theme's own drawer the cart icon is a button - the /cart link would leave the page.
  const themeBtn = document.querySelector("button.slide-menu-cart");
  if (themeBtn) { themeBtn.click(); return; }
  window.location.href = "/cart";
}

/* ---------- Sticky add to cart bar ---------- */
document.addEventListener("DOMContentLoaded", function () {
  const bar = document.getElementById("sticky-add-to-cart");
  const productBox = document.getElementById("product-box");
  if (bar && productBox && "IntersectionObserver" in window) {
    new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) bar.classList.remove("show");
        else bar.classList.add("show");
      });
    }, { threshold: 0 }).observe(productBox);
  }

  const stickyVariant = document.getElementById("sticky-variant");
  const stickyQty = document.getElementById("sticky-quantity");
  const stickyBtn = document.getElementById("sticky-add-btn");
  const mainPrice = document.querySelector(".main-price");
  const comparePrice = document.querySelector(".compare-price");
  const mainForm = document.querySelector("form.shopify-product-form");

  function updateStickyPrice() {
    if (!stickyVariant || !stickyVariant.options.length) return;
    const opt = stickyVariant.options[stickyVariant.selectedIndex];
    const price = opt.getAttribute("data-price");
    const compare = opt.getAttribute("data-compare-price");
    // Prices come through with the store's money HTML (<span class=money>), so show the text only.
    const clean = v => (v || "").replace(/<[^>]*>/g, "").trim();
    if (price && mainPrice) mainPrice.textContent = clean(price);
    if (comparePrice) {
      if (compare && compare !== price) { comparePrice.textContent = clean(compare); comparePrice.style.display = "inline"; }
      else comparePrice.style.display = "none";
    }
  }

  // Keep the sticky bar in step with the main product options (variant + quantity).
  function syncFromMainForm() {
    if (!mainForm || !stickyVariant) return;
    const idInput = mainForm.querySelector('[name="id"]');
    if (idInput && idInput.value && stickyVariant.querySelector('option[value="' + idInput.value + '"]')) {
      stickyVariant.value = idInput.value;
      updateStickyPrice();
    }
    const qtyInput = mainForm.querySelector('[name="quantity"]');
    if (qtyInput && stickyQty && qtyInput.value) stickyQty.value = qtyInput.value;
  }
  if (mainForm) {
    ["change", "input", "click"].forEach(evt =>
      mainForm.addEventListener(evt, () => { setTimeout(syncFromMainForm, 60); setTimeout(syncFromMainForm, 500); })
    );
    syncFromMainForm();
  }

  // If the customer changes the fabric in the sticky bar, apply it to the main options too,
  // so what they see on the page and what goes in the cart always match.
  function pushToMainForm() {
    if (!mainForm || !stickyVariant) return;
    const opt = stickyVariant.options[stickyVariant.selectedIndex];
    if (!opt) return;
    const values = opt.textContent.split(" / ").map(v => v.trim());
    const selects = [...mainForm.querySelectorAll("select:not([name='id'])")].filter(sel => sel.options.length);
    values.forEach((val, i) => {
      const sel = selects[i];
      if (sel && [...sel.options].some(o => o.value === val) && sel.value !== val) {
        sel.value = val;
        sel.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }
  if (stickyVariant) stickyVariant.addEventListener("change", () => { updateStickyPrice(); pushToMainForm(); });

  // Products with no options (e.g. sample packs): hide the "Default Title" dropdown in the sticky bar.
  if (stickyVariant && stickyVariant.options.length === 1 && /^default title$/i.test(stickyVariant.options[0].textContent.trim())) {
    stickyVariant.style.display = "none";
    const actions = stickyVariant.closest(".product-actions");
    if (actions) actions.classList.add("mr-single-variant");
  }
  updateStickyPrice();

  if (stickyBtn && stickyVariant) {
    stickyBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const id = stickyVariant.value;
      const qty = parseInt(stickyQty && stickyQty.value, 10) || 1;
      const mainAdd = mainForm && mainForm.querySelector('button[name="add"], [type="submit"][name="add"]');
      // Preferred: press the main Add button so iCart adds the item and opens its drawer exactly as usual.
      if (mainAdd) {
        const qtyInput = mainForm.querySelector('[name="quantity"]');
        if (qtyInput) qtyInput.value = qty;
        mainAdd.click();
        return;
      }
      // Fallback (no main form on the page): add directly, then go to the cart.
      const min = stickyQty && stickyQty.min;
      const body = { id: id, quantity: qty };
      if (min) body.properties = { _minquantity: min };
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(body)
      })
        .then(r => r.json().then(data => ({ ok: r.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) throw new Error((data && (data.description || data.message)) || "Could not add to cart");
          window.location.href = "/cart";
        })
        .catch(err => { alert(err.message || "Sorry, something went wrong adding to cart. Please try again."); });
    });
  }
});

/* ---------- Phones: slimmer sticky bar + chat bubble kept clear of the product options ---------- */
(function () {
  const bar = document.getElementById("sticky-add-to-cart");
  if (!bar) return; // product pages only
  const css = document.createElement("style");
  css.textContent = "@media (max-width:767px){" +
    ".sticky-cart{padding:8px 12px!important}" +
    ".sticky-cart .product-image,.sticky-cart .product-info h3{display:none!important}" +
    ".sticky-cart .product-info{margin:0!important}" +
    ".sticky-cart .product-info .price{margin:0 0 6px!important;font-size:14px;font-weight:600;line-height:1.2}" +
    ".sticky-cart .product-actions{display:grid!important;grid-template-columns:minmax(0,1fr) 64px;gap:8px!important}" +
    ".sticky-cart .product-actions select{width:100%;min-width:0;height:38px}" +
    ".sticky-cart .product-actions input{width:64px!important;height:38px}" +
    ".sticky-cart .product-actions .button{grid-column:1/-1;padding:10px!important;font-weight:600}" +
    ".sticky-cart .product-actions.mr-single-variant{grid-template-columns:64px minmax(0,1fr)}" +
    ".sticky-cart .product-actions.mr-single-variant .button{grid-column:auto}" +
    "}";
  document.head.appendChild(css);

  // Shopify Inbox chat bubble: sits low in the corner, and moves up above the sticky bar while it's showing.
  function placeChat() {
    const host = document.querySelector("shopify-chat");
    if (!host) return false;
    if (window.innerWidth >= 768) { host.style.removeProperty("--shopify-chat-activator-offset"); return true; }
    const shown = bar.classList.contains("show");
    host.style.setProperty("--shopify-chat-activator-offset", shown ? (bar.offsetHeight + 10) + "px" : "16px");
    return true;
  }
  new MutationObserver(placeChat).observe(bar, { attributes: true, attributeFilter: ["class"] });
  window.addEventListener("resize", placeChat);
  let tries = 0;
  const wait = setInterval(() => { if (placeChat() || ++tries > 40) clearInterval(wait); }, 500);
})();

/* ---------- Quick view: fetch the pop-up content only when someone taps Quick view ----------
 * Collection pages used to carry the full quick-view content for every product (7-15 MB of HTML).
 * snippets/quick-view.liquid now leaves it empty (template[data-mr-lazy]); this loads it from
 * /products/<handle>?view=mrqv on first tap, then lets the theme's own quick view open as normal. */
document.addEventListener("click", function (e) {
  const btn = e.target && e.target.closest ? e.target.closest(".quick-view-btn-container button") : null;
  if (!btn) return;
  const qv = btn.closest("quick-view");
  const tpl = qv && qv.querySelector("template[data-mr-lazy]");
  if (!tpl || tpl.dataset.mrLoaded === "1") return;
  e.preventDefault();
  e.stopImmediatePropagation();
  if (tpl.dataset.mrLoading === "1") return;
  tpl.dataset.mrLoading = "1";
  btn.style.cursor = "progress";
  const url = tpl.getAttribute("data-mr-lazy").split("?")[0];
  // 23 Oct: the quick-view script itself is lazy too (snippets/quick-view-drawer.liquid) - make sure it has arrived before re-clicking.
  const scriptReady = window.mrQvLoad ? window.mrQvLoad() : Promise.resolve();
  Promise.all([
    fetch(url + "?view=mrqv", { credentials: "same-origin" }).then(r => { if (!r.ok) throw new Error("HTTP " + r.status); return r.text(); }),
    scriptReady
  ])
    .then(([html]) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const srcTpl = doc.querySelector("quick-view template");
      const json = doc.querySelector("script.quick-view-json");
      if (!srcTpl || !json) throw new Error("Quick view content missing");
      tpl.content.appendChild(document.importNode(srcTpl.content, true));
      const s = document.createElement("script");
      s.type = "application/json";
      s.className = "quick-view-json";
      s.id = json.id;
      s.textContent = json.textContent;
      qv.appendChild(s);
      tpl.dataset.mrLoaded = "1";
      tpl.dataset.mrLoading = "";
      btn.style.cursor = "";
      btn.click();
    })
    .catch(() => { window.location.href = url; });
}, true);

/* ---------- Mobile menu sub-images ---------- */
$(".mobile-menu-link__has-submenu .mobile-menu-link").click(function () {
  const sub = $(this).data("subimage");
  $(".mobile_wrapper_images").removeClass("active");
  $(".mobile_wrapper_images." + sub).addClass("active");
});

/* ---------- Wishlist buttons (legacy) ---------- */
function show_wishlist() { $(".swym-button").show(); }
setTimeout(show_wishlist, 2000);

/* ---------- Product gallery (Swiper) ---------- */
if (window.Swiper && document.querySelector(".gallery-main")) {
  const sliderPosition = $("#product-box").data("slider");
  const galleryThumbs = new Swiper(".gallery-thumbs", {
    centeredSlides: true, centeredSlidesBounds: true, slidesPerView: 5,
    watchOverflow: true, watchSlidesVisibility: true, watchSlidesProgress: true,
    direction: sliderPosition
  });
  new Swiper(".gallery-main", {
    autoHeight: true, watchOverflow: true, watchSlidesVisibility: true, watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    thumbs: { swiper: galleryThumbs }
  });
}

/* ---------- Testimonials equal height ---------- */
function setEHeight() {
  const items = document.querySelectorAll(".testimonial-text");
  if (!items.length) return;
  const max = Math.max(...[...items].map(e => e.offsetHeight));
  items.forEach(e => { e.style.height = max + "px"; });
}
setEHeight();

/* ---------- Flickity sliders (wait for the library) ---------- */
function mrWhenFlickity(cb, tries) {
  tries = tries || 0;
  if ($.fn && $.fn.flickity) { cb(); return; }
  if (tries < 100) setTimeout(() => mrWhenFlickity(cb, tries + 1), 100);
}

function handleFlickity(selector) {
  const el = $(selector);
  if (!el.length) return;
  if (window.innerWidth < 767) {
    if (!el.hasClass("flickity-enabled")) el.flickity({ cellAlign: "left", pageDots: true, prevNextButtons: true, wrapAround: true, contain: true });
  } else if (el.hasClass("flickity-enabled")) {
    el.flickity("destroy");
  }
}
function initMobileSliders() {
  handleFlickity(".icon-with-text-main");
  handleFlickity(".homepage-featured-products.enable-mobile-slider");
}

mrWhenFlickity(function () {
  if ($(".product-review-slider-grid").length > 0) {
    $(".product-review-slider-grid").flickity({ cellAlign: "left", pageDots: false, wrapAround: true, contain: true });
  }
  $(document).ready(initMobileSliders);
  $(window).on("resize", initMobileSliders);

  if ($(".custom_svg_wrap").length > 0 && window.innerWidth < 480) {
    $(".custom_svg_wrap").flickity({ cellAlign: "left", pageDots: true, prevNextButtons: false, wrapAround: true, contain: true });
  }
  if ($(".template-index .collection-grid .row").length > 0 && window.innerWidth < 767) {
    $(".template-index .collection-grid .row").flickity({ cellAlign: "left", pageDots: true, prevNextButtons: true, wrapAround: true, contain: true });
  }
  if ($(".new-icon-with-text__main").length > 0 && window.innerWidth < 767) {
    $(".new-icon-with-text__main").flickity({ cellAlign: "left", pageDots: true, prevNextButtons: false, wrapAround: true, contain: true });
  }

  let recTries = 0;
  const recInterval = setInterval(() => {
    recTries++;
    const wrap = $(".recommendation-grid__item-wrapper");
    if (wrap.length) {
      if (wrap.find(".grid__item").length > 4) {
        wrap.flickity({ cellAlign: "left", pageDots: false, prevNextButtons: true, wrapAround: true, contain: true });
      }
      clearInterval(recInterval);
    } else if (recTries > 40) {
      clearInterval(recInterval);
    }
  }, 500);
});

/* ---------- Collection menu accordion ---------- */
$(".collection-menu--list-item .collection-menu--list-item_btn").on("click", function () {
  $(this).toggleClass("active").next().slideToggle();
  $(".collection-menu--list-item .collection-menu--list-item_btn").not($(this)).removeClass("active");
  $(".collection-menu--list-items_content").not($(this).next()).slideUp(300);
  $(this).siblings().removeClass("active");
});

/* ---------- Quick add buttons (.custom-atc-button) ---------- */
$(document).on("click", ".custom-atc-button button", function (e) {
  e.preventDefault();
  const variantId = $(this).data("variant-id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    dataType: "json",
    contentType: "application/json",
    success: function () { mrOpenCartDrawer(); },
    error: function (xhr) { console.error("Error adding to cart:", xhr.responseText); }
  });
});

/* ---------- Accessibility touch-ups for app widgets (Claude, 8 Oct) ----------
 * Klaviyo and other apps add their own HTML after the page loads; this fills in the missing labels/alt text
 * Google flags (coupon link, popup images). Runs again whenever they redraw. */
(function () {
  function fix() {
    document.querySelectorAll("img.needsclick:not([alt])").forEach(function (img) { img.setAttribute("alt", ""); });
    document.querySelectorAll('a[href^="javascript:"]').forEach(function (a) {
      a.removeAttribute("href");
      a.setAttribute("role", "button");
      if (!a.hasAttribute("tabindex")) a.setAttribute("tabindex", "0");
      a.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); a.click(); } });
    });
    const sv = document.getElementById("sticky-variant"); if (sv && !sv.hasAttribute("aria-label")) sv.setAttribute("aria-label", "Choose fabric option");
    const sq = document.getElementById("sticky-quantity"); if (sq && !sq.hasAttribute("aria-label")) sq.setAttribute("aria-label", "Quantity");
    document.querySelectorAll('select[name="sort_by"]:not([aria-label])').forEach(function (s) { s.setAttribute("aria-label", "Sort products"); });
    document.querySelectorAll('input[name="q"]:not([aria-label])').forEach(function (i) { i.setAttribute("aria-label", "Search"); });
    document.querySelectorAll(".product-review-image img:not([alt])").forEach(function (img) { img.setAttribute("alt", "Customer photo"); });
  }
  /* 23 Oct (speed): this used to re-scan the whole page 150ms after EVERY DOM change for as long as the tab was open (~0.8s of phone CPU
     during load, per Google's test). Now: one pass at DOMContentLoaded, one after load, then a lightly-debounced pass while the app
     widgets (Klaviyo, Judge.me) are still drawing, and the watcher switches itself off 25s after load. The cart drawer is
     re-checked when it opens, since it draws its contents on demand. */
  let t, stopped = false;
  const run = function () { if (stopped) return; clearTimeout(t); t = setTimeout(fix, 600); };
  const mo = new MutationObserver(run);
  const start = function () { fix(); mo.observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
  window.addEventListener("load", function () {
    setTimeout(fix, 1200);
    setTimeout(function () { stopped = true; mo.disconnect(); }, 25000);
  });
  document.addEventListener("click", function (e) {
    const t2 = e.target && e.target.closest && e.target.closest("[href='/cart'], [href='#cart'], form[action*='/cart/add'] [type=submit], [data-quick-view-trigger]");
    if (t2) { setTimeout(fix, 700); setTimeout(fix, 2000); }
  }, true);
})();
